import { useMemo } from 'react';
import { EMPLOYMENT_TYPES } from '../../../constants';
import { addUTMSource } from '../../../helpers/queryString';
import { moveRemoteToEnd } from '../../../helpers/array';
import { displayCompensationPeriodLabel } from '../../../helpers/jobs';

export const useJobsLabel = (
  {
    compensationCurrency,
    compensationAmountMaxCents,
    compensationAmountMinCents,
    compensationPeriod,
    compensationOffersEquity,
    jobFunctions = [],
    employmentTypes = [],
    locations,
    applicationMethod,
    applicationPath,
    url,
  },
  network,
) => {
  const compensationLabel = useMemo(() => {
    if (!compensationAmountMinCents || !compensationAmountMaxCents) {
      return '';
    }

    return displayCompensationPeriodLabel({
      amountMinCents: compensationAmountMinCents,
      amountMaxCents: compensationAmountMaxCents,
      currency: compensationCurrency,
      period: compensationPeriod,
      offersEquity: compensationOffersEquity,
    });
  }, [
    compensationAmountMinCents,
    compensationAmountMaxCents,
    compensationCurrency,
    compensationPeriod,
    compensationOffersEquity,
  ]);

  const jobFunctionsLabel = jobFunctions
    .map((jf) => jf.name)
    .filter((name) => !/[()]/g.test(name))
    .join(', ');

  const employmentTypesLabel = employmentTypes
    .map((employmentType) => EMPLOYMENT_TYPES.find(({ value }) => value === employmentType)?.label)
    .join(', ');

  const locationsLabel = moveRemoteToEnd(locations.map((location) => location.name)).join(' · ');

  const applicationUrl = useMemo(() => {
    if (applicationMethod === 'url') {
      return addUTMSource(applicationPath, network.name);
    }

    if (applicationMethod === 'email') {
      return `mailto:${applicationPath}`;
    }

    if (applicationMethod === 'method_not_defined') {
      return addUTMSource(url, network.name);
    }

    return null;
  }, [applicationMethod, applicationPath, network.name, url]);

  return {
    compensationLabel,
    jobFunctionsLabel,
    employmentTypesLabel,
    locationsLabel,
    applicationUrl,
  };
};
